import { BrowserRouter, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { useAuth, AuthProvider } from './context/AuthContext';
import LoginScreen from './screens/LoginScreen';
import HomeScreen from './screens/HomeScreen';
import TasksScreen from './screens/TasksScreen';
import EmailsScreen from './screens/EmailsScreen';
import CalendarScreen from './screens/CalendarScreen';
import LinkedInScreen from './screens/LinkedInScreen';

// ─── Nav items ────────────────────────────────────────────────────────────────

const NAV = [
  { path: '/',         emoji: '⚡', label: 'Dashboard' },
  { path: '/tasks',    emoji: '✅', label: 'Tasks' },
  { path: '/emails',   emoji: '📧', label: 'Emails' },
  { path: '/calendar', emoji: '📅', label: 'Calendar' },
  { path: '/linkedin', emoji: '💼', label: 'LinkedIn' },
];

// ─── Shell (authenticated layout) ────────────────────────────────────────────

function AppShell() {
  const { email, logout } = useAuth();

  return (
    <div className="app-shell">
      {/* Topbar */}
      <header className="topbar">
        <a href="/" className="topbar-logo">
          ⚡ Ward<span>yn</span>
          <span className="topbar-badge">LIVE</span>
        </a>
        <div className="topbar-user">
          <span title="30-second live sync">
            <span className="poll-dot" />
          </span>
          <span>{email}</span>
          <button className="btn-logout" onClick={logout}>Sign out</button>
        </div>
      </header>

      {/* Sidebar */}
      <nav className="sidebar">
        {NAV.map(({ path, emoji, label }) => (
          <NavLink
            key={path}
            to={path}
            end={path === '/'}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="nav-emoji">{emoji}</span>
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Main */}
      <main>
        <Routes>
          <Route path="/"         element={<HomeScreen />} />
          <Route path="/tasks"    element={<TasksScreen />} />
          <Route path="/emails"   element={<EmailsScreen />} />
          <Route path="/calendar" element={<CalendarScreen />} />
          <Route path="/linkedin" element={<LinkedInScreen />} />
          <Route path="*"         element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

// ─── Auth Gate ────────────────────────────────────────────────────────────────

function AuthGate() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0A0A0F' }}>
      <span style={{ color: '#8888A8', fontSize: 16 }}>Loading Wardyn…</span>
    </div>
  );
  return isAuthenticated ? <AppShell /> : <LoginScreen />;
}

// ─── Root App ─────────────────────────────────────────────────────────────────

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AuthGate />
      </BrowserRouter>
    </AuthProvider>
  );
}
